export const EDIT_ACCOUNT = '#/localMerchant/settlementAccount/editAccount' // 绑卡编辑页面
export const BIND_AUTH = '#/localMerchant/settlementAccount/bindAuth' // 小额鉴权页面
export const ACCOUNT_REVIEW = '#/localMerchant/settlementAccount/accountReview' // 绑卡审核页面
export const REAINAME_AUTH = '#/localMerchant/realnameAuthentication' // 实名认证页面
export const SETTLEMENT_ACCOUTN = '#/localMerchant/settlementAccount'
export const COMPONY_CHOOSE = '#/localMerchant/settlementAccount/componyChoose'

// 绑卡审核审核状态
export const UN_BOND = 0 // 未绑定
export const SMALLL_AUTH = 1 // 小额鉴权
export const UNDER_REVIEW = 2 // 审核中
export const FAIL_REVIEW = 3 // 审核失败
export const SUCCESS_BIND = 4 // 绑卡成功

// 绑卡类型
export const COMPONY_BANK = 1 // 企业银行
export const COMPONY_LEGEN = 2 // 企业法人
export const COMPONY_OTHER = 3 // 企业他人(本次迭代隐藏)
export const IS_INDIVIDUAL = 4 // 个体工商户（新增）
export const PERSONAL_BANK = 5 // 个人银行(后台数据为1，本地为了和企业区分修改)
export const PERSONAL_OTHER = 6 // 个人他人(后台数据为2，本地为了和企业区分修改)(本次迭代隐藏)

export const modalData = {
  // 商家审核
  MerchantReview: {
    maskClosable: true,
    content: '当前店铺处于入驻审核阶段，不可编辑店铺信息',
    okText: '确定'
  },
  // 实名认证
  Verified: {
    maskClosable: true,
    title: '账户提现须知',
    content:
      '亲爱的商家，为响应监管部门合规要求，请先完成商家实名认证，再进行提现操作。',
    okText: '立即认证',
    cancelText: '取消',
    onOk: () => {
      window.location.hash = REAINAME_AUTH
    }
  },
  // 未绑定
  UnBind: {
    maskClosable: true,
    title: '绑定结算账户通知',
    content:
      '亲爱的商家，为响应监管部门合规要求，保障平台资金安全，提升商家提现到账速度。即日起，婚礼纪将把平台交易资金存放至银行交易资金专用类账户。故需要您重新绑定提现结算账户，来进行提现操作。给您带来的不便，敬请谅解',
    okText: '立即绑定',
    cancelText: '取消'
  },
  // 小额鉴权
  SmallAuth: {
    maskClosable: true,
    content: '结算账户待确认收款金额，当前无法进行提现操作',
    okText: '确认收款金额',
    cancelText: '取消',
    onOk: () => {
      window.location.hash = BIND_AUTH
    }
  },
  // 解绑账户存在提现中金额
  Untie: {
    maskClosable: true,
    title: '无法修改绑定账户',
    content: '当前有资金提现中，请完成后再试',
    okText: '确 定'
  },
  // 确认解绑
  isUntie: {
    maskClosable: true,
    title: '是否确认修改绑定账户',
    content: '确定后，将与原账户解绑',
    cancelText: '取 消',
    okText: '确 定'
  },
  // 解绑成功
  untieSuccess: {
    maskClosable: true,
    title: '解绑成功',
    content: '是否立即绑定新的结算账户',
    cancelText: '取 消',
    okText: '立即绑定'
  },

  checkOk: {
    title: '验证通过',
    content: '结算账户绑定成功',
    okText: '返回'
  },
  //修改确认
  modify: {
    maskClosable: true,
    title: '确定修改账户？',
    content: '确定后，已登记的账户信息将被删除',
    okText: '确认',
    cancelText: '取消'
  },
  // 本次迭代不涉及
  // 审核中
  UnderReview: {
    maskClosable: true,
    content: '结算账户修改审核中，当前无法进行提现操作',
    okText: '查看进度',
    cancelText: '取消',
    onOk: () => {
      window.location.hash = ACCOUNT_REVIEW
    }
  },
  // 审核失败
  FailReview: {
    maskClosable: true,
    content: '结算账户修改审核不通过，如有需要请修改后重新提交',
    okText: '重新提交',
    cancelText: '取消',
    onOk: () => {
      window.location.hash = ACCOUNT_REVIEW
    }
  }
}
